import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SectionHeaderComponent } from 'src/main/cms/Sports/SportsForm/SectionHeader';
import { CustomizedSportsState } from 'src/AppState/CmsState/SportsState/SportsState';
import { ImageUploadForm } from 'src/main/cms/Sports/SportsForm/ImageUploadForm';
import { AddSportColorsForm } from 'src/main/cms/Sports/SportsForm/AddSportColorsForm';
// import { ScoreboardsForm } from './ScoreboardsForm';

interface PropsTypes {
    sportState: CustomizedSportsState;
}

export const SportsHeaderForm = observer('SportsForm', ({ sportState }: PropsTypes) => {
    const {
        sportLabel,

        sportLabelColor,
        sportHeaderBgColor,

        headerImageDesktop,
        headerImageMobile,
        headerImageTablet,

        setHeaderTextColor,
        setHeaderBgColor,

        resetColors,
        isOpenSections,
    } = sportState;

    return (
        <>
            {/* Change sport label - use after merging Sports and Special Sports into one tab */}
            {/* <Input
                    label='Sport label'
                    formInputState={sportLabel}
                    hasOutline={false}
                /> */}

            <SectionHeaderComponent
                subSection={true}
                label='Change header colors'
                sectionType='colorPicker'
                sportState={sportState}
            />

            {isOpenSections.colorPicker ? (
                <AddSportColorsForm
                    label='Sport header'
                    sportLabel={sportLabel.value}
                    textColor={sportLabelColor}
                    bgColor={sportHeaderBgColor}
                    setHeaderTextColor={setHeaderTextColor}
                    setHeaderBgColor={setHeaderBgColor}
                    resetColors={resetColors}
                />
            ) : null}

            <SectionHeaderComponent
                subSection={true}
                label='Change background image'
                sectionType='imageUpload'
                sportState={sportState}
                data-test='customize-existing-sport-change-image'
            />

            {isOpenSections.imageUpload ? (
                <ImageUploadForm
                    imageDesktop={headerImageDesktop}
                    imageTablet={headerImageTablet}
                    imageMobile={headerImageMobile}
                    dataTest='customize-sport'
                />
            ) : null}
        </>
    );
});
